import dateFns from 'date-fns';
import fp from 'lodash/fp';
import React from 'react';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardImg, CardSubtitle, CardTitle, Col, Container, Dropdown, DropdownMenu, DropdownToggle, FormGroup, Jumbotron, Row } from 'reactstrap';
import { compose, pure, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { nonFixedUnion } from '../../../../common';
import { routes } from '../../../../constants';
import actions from '../../../../state/actions';
import './events.css';
import eventsQuery from './events.gql';

const Events = ({
  data: {
    events,
    eventLocations
  },
  filters,
  setFilterIsOpen,
  setFilterSelectedValues
}) => (
    <section className='events'>
      <Jumbotron tag='section' className='text-center'>
        <Container>
          <h1>Events</h1>
        </Container>
      </Jumbotron>
      <div className='album text-muted'>
        <Container>
          <Row className='mb-4'>
            {
              fp.flow(
                fp.toPairs,
                fp.filter(fp.getOr(false)('[1].length')),
                fp.map(
                  ([key, values]) => fp.flow(
                    fp.get(key),
                    ({
                      isOpen,
                      selectedValues
                    }) => ({
                      key,
                      selectedValues,
                      value: {
                        isOpen,
                        values: fp.map((value) => ({
                          selected: fp.includes(value)(selectedValues),
                          value
                        }))(values)
                      }
                    })
                  )(filters)
                ),
                fp.map(({ key, selectedValues, value: { isOpen, values } }) => (
                  <Col key={key} xs={12} sm={6} md={true} className='flex-center'>
                    <Dropdown isOpen={isOpen} toggle={() => setFilterIsOpen(key, !isOpen)}>
                      <DropdownToggle caret color='primary'>
                        {key}
                      </DropdownToggle>
                      <DropdownMenu>
                        {
                          fp.map(({ selected, value }) => (
                            <FormGroup key={value}>
                              <input
                                id={value}
                                type='checkbox'
                                checked={selected}
                                onChange={() =>
                                  setFilterSelectedValues(key, (selected ?
                                    fp.remove(fp.partial(fp.eq, [value])) :
                                    fp.concat(value)
                                  )(selectedValues))} />
                              <label htmlFor={value}>
                                {value}
                              </label>
                            </FormGroup>
                          ))(values)
                        }
                      </DropdownMenu>
                    </Dropdown>
                  </Col>
                ))
              )({
                continent: fp.flow(
                  fp.map(({ continent }) => continent),
                  fp.uniq,
                  fp.filter(fp.identity)
                )(eventLocations),
                country: fp.flow(
                  fp.map(({ country }) => country),
                  fp.uniq,
                  fp.filter(fp.identity)
                )(eventLocations),
                state: fp.flow(
                  fp.map(({ state }) => state),
                  fp.uniq,
                  fp.filter(fp.identity)
                )(eventLocations),
                city: fp.flow(
                  fp.map(({ city }) => city),
                  fp.uniq,
                  fp.filter(fp.identity)
                )(eventLocations),
                show: [
                  'Upcoming',
                  'Past'
                ]
              })
            }
          </Row>
          {
            fp.flow(
              fp.sortBy(({ startDate }) => parseInt(dateFns.format(startDate, 'YYYYMMDD'), 10)),
              fp.chunk(3),
              fp.map((chunk) =>
                <Row key={fp.flow(fp.map(({ id }) => id), fp.join(' '))(chunk)}>
                  {
                    fp.map(({ id, image, location: { city, country }, name, startDate }) =>
                      <Col key={`${id}-${startDate}`} xs={12} md={4}>
                        <Card>
                          <Link to={routes.event(id)}>
                            <CardImg top width='100%' src={image} />
                          </Link>
                          <CardBody>
                            <Row>
                              <Col xs={12} sm={3} md={12} lg={3} className='flex-center'>
                                <p className='text-center'>
                                  <strong>
                                    {dateFns.format(startDate, 'Do MMM')}
                                  </strong>
                                  <br />
                                  {dateFns.getYear(startDate)}
                                </p>
                              </Col>
                              <Col xs={12} sm={9} md={12} lg={9}>
                                <CardTitle className='flex-center text-center'>
                                  <Link to={routes.event(id)}>
                                    {name}
                                  </Link>
                                </CardTitle>
                                <CardSubtitle className='flex-center text-center'>
                                  {
                                    fp.flow(
                                      fp.filter(fp.identity),
                                      fp.join(', ')
                                    )([city, country])
                                  }
                                </CardSubtitle>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    )(chunk)
                  }
                </Row>
              )
            )(events)
          }
        </Container>
      </div>
    </section>
  );

export default compose(
  connect(({ events: { filters } }) => ({
    filters
  }), (dispatch) => ({
    setFilterIsOpen: bindActionCreators(actions.events.filters.setIsOpen, dispatch),
    setFilterSelectedValues: bindActionCreators(actions.events.filters.setSelectedValues, dispatch)
  })),
  withProps(({ filters: { city, continent, country, state, show } }) => ({
    filter: {
      locationFilters: nonFixedUnion(
        fp.map((value) => ({ city: value }))(city.selectedValues),
        fp.map((value) => ({ continent: value }))(continent.selectedValues),
        fp.map((value) => ({ country: value }))(country.selectedValues),
        fp.map((value) => ({ state: value }))(state.selectedValues)
      ),
      ...(
        ({
          includePast,
          includeFuture
        }) =>
          includePast && !includeFuture ?
            { isPast: true } :
            !includePast && includeFuture ?
              { isFuture: true } :
              {}
      )({
        includePast: fp.includes('Past')(show.selectedValues),
        includeFuture: fp.includes('Upcoming')(show.selectedValues)
      })
    }
  })),
  graphql(eventsQuery),
  pure
)(Events);



// WEBPACK FOOTER //
// ./src/components/pages/app/events/events.js